import { create } from 'zustand';
import { ViewMode } from '@/types/features';

interface ViewModeState {
    viewMode: ViewMode;
    setViewMode: (mode: ViewMode) => void;
}

export const useViewModeStore = create<ViewModeState>((set) => ({
    viewMode: 'normal',
    setViewMode: (mode) => set({ viewMode: mode }),
}));
